import { render, staticRenderFns } from "./Pagenotfound.vue?vue&type=template&id=bd7b1924&scoped=true"
import script from "./Pagenotfound.vue?vue&type=script&lang=js"
export * from "./Pagenotfound.vue?vue&type=script&lang=js"
import style0 from "./Pagenotfound.vue?vue&type=style&index=0&id=bd7b1924&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd7b1924",
  null
  
)

export default component.exports